<script>
import { validationMixin } from 'vuelidate'
import { minLength, required } from 'vuelidate/lib/validators'

import validationFormMixin from '@/mixins/validation.mixin'

const latitudeValidation = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }

  return /^-?(90(\.0{0,6})?|[1-8]?\d(\.\d{0,6})?)$/.test(value.toString())
}

const longitudeValidation = (value) => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }

  return /^-?(180(\.0{0,6})?|([1-9]|1[0-7])?\d(\.\d{0,6})?)$/.test(
    value.toString()
  )
}

export default {
  name: 'PontoColetaForm',
  mixins: [validationMixin, validationFormMixin],
  props: {
    ponto: {
      type: Object,
      required: false,
    },
    tiposDadoColeta: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      form: {
        id: null,
        nome: '',
        periodicidade: 'DIARIO',
        topico: 'AGUA_TRATADA',
        coletaParametros: [],
        latitude: null,
        longitude: null,
      },
      tempColetaParametro: null,
    }
  },
  validations: {
    form: {
      nome: {
        required,
      },
      periodicidade: {
        required,
      },
      coletaParametros: {
        required,
        minLength: minLength(1),
      },
      latitude: {
        required,
        latitudeValidation,
      },
      longitude: {
        required,
        longitudeValidation,
      },
      topico: {
        required,
      },
    },
  },
  beforeMount() {
    if (this.ponto) {
      let periodicidade = 'DIARIO'

      if (
        this.ponto?.coletaParametros &&
        this.ponto?.coletaParametros.length > 0
      ) {
        periodicidade = this.ponto?.coletaParametros[0].periodicidade
      }

      let topico = 'AGUA_TRATADA'

      if (
        this.ponto?.coletaParametros &&
        this.ponto?.coletaParametros.length > 0
      ) {
        topico = this.ponto?.coletaParametros[0].topico
      }

      this.form = {
        ...this.ponto,
        periodicidade: periodicidade,
        topico: topico,
        coletaParametros:
          this.ponto?.coletaParametros?.map((t) => t.tipo) ?? [],
      }
    }
  },
  methods: {
    validateAndGet() {
      this.$v.$touch()

      return [!this.$v.$invalid, this.form]
    },
  },
}
</script>

<template>
  <div class="row">
    <div class="col-3">
      <md-field :class="getValidationClass('nome')">
        <label for="nome">Nome</label>
        <md-input id="nome" v-model="form.nome" name="nome" />
        <span v-if="!$v.form.nome.required" class="md-error"
          >Nome inválido</span
        >
      </md-field>
    </div>

    <div class="col-1">
      <md-field :class="getValidationClass('topico')">
        <label for="topico">Topico</label>
        <md-select id="topico" v-model="form.topico" name="topico">
          <md-option value="AGUA_TRATADA"> Água tratada </md-option>
          <md-option value="CAPTACAO"> Captação </md-option>
          <md-option value="REDE"> Rede </md-option>
          <md-option value="OPERACAO"> Operação </md-option>
        </md-select>
        <span v-if="!$v.form.topico.required" class="md-error"
          >Tópido inválida</span
        >
      </md-field>
    </div>

    <div class="col-1">
      <md-field :class="getValidationClass('latitude')">
        <label for="latitude">Latitude</label>
        <md-input
          id="latitude"
          v-model.number="form.latitude"
          v-coordinate-decimals
          name="latitude"
          type="number"
          step="0.000001"
        />
        <span v-if="!$v.form.latitude.required" class="md-error">
          Latitude é obrigatória
        </span>
        <span v-if="!$v.form.latitude.latitudeValidation" class="md-error">
          Latitude inválida
        </span>
      </md-field>
    </div>

    <div class="col-1">
      <md-field :class="getValidationClass('longitude')">
        <label for="longitude">Longitude</label>
        <md-input
          id="longitude"
          v-model.number="form.longitude"
          v-coordinate-decimals
          name="longitude"
          type="number"
          step="0.000001"
        />
        <span v-if="!$v.form.longitude.required" class="md-error">
          Longitude é obrigatória
        </span>
        <span v-if="!$v.form.longitude.longitudeValidation" class="md-error">
          Longitude inválida
        </span>
      </md-field>
    </div>

    <div class="col-1">
      <md-field :class="getValidationClass('periodicidade')">
        <label for="periodicidade">Periodicidade</label>
        <md-select
          id="periodicidade"
          v-model="form.periodicidade"
          name="periodicidade"
        >
          <md-option value="DIARIO"> DIÁRIO </md-option>
          <md-option value="SEMANAL"> SEMANAL </md-option>
        </md-select>
        <span v-if="!$v.form.periodicidade.required" class="md-error"
          >Periodicidade inválida</span
        >
      </md-field>
    </div>

    <div class="col-3">
      <md-field :class="getValidationClass('coletaParametros')">
        <label for="coletaParametros">Parâmetros</label>
        <md-select
          id="coletaParametros"
          v-model="form.coletaParametros"
          name="coletaParametros"
          md-dense
          multiple
        >
          <md-option v-for="v in tiposDadoColeta" :key="v.tipo" :value="v.tipo">
            {{ v.tipo }}
          </md-option>
        </md-select>
        <span v-if="!$v.form.coletaParametros.required" class="md-error"
          >Tipos de dados inválido</span
        >
      </md-field>
    </div>

    <div class="col-1">
      <md-button
        class="md-icon-button"
        @click="() => $emit('onTrash', { ...form })"
      >
        <md-icon>delete</md-icon>
      </md-button>
    </div>
  </div>
</template>

<style scoped lang="scss"></style>
